<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <div class="kt-form w-webkit-fill-available">
    <div class="modal-content">

      <div class="modal-header">
        <h5 *ngIf="!isTemplateSelectionMode" class="modal-title">{{ titleAction }} Blacklist Template {{ form?.value?.name ? ('- ' + form?.value?.name) : '' }}</h5>
        <h5 *ngIf="isTemplateSelectionMode" class="modal-title">Game Provider Blacklist</h5>
        <span class="modal-x-button" (click)="onCloseDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>

      <div class="modal-body">
        <form [formGroup]="form">

          <span *ngIf="!isTemplateSelectionMode">
            <!-- Basic Info -->
            <div class="mb-3"><b>Basic Info</b></div>

            <div class="row mb-3">
              <div class="col-md-6">
                <label>Label: <span class="text-red">*</span></label>
                <input class="form-control" formControlName="name" placeholder="Label" />
              </div>

              <!-- <div class="col-md-6">
                <label>Status: <span class="text-red">*</span></label>
                <select class="form-control" formControlName="status">
                  <option [value]="i" *ngFor="let s of dropdown.statuses; let i = index">{{ s }}</option>
                </select>
              </div> -->
            </div>

            <div class="row mb-4">
              <div class="col-md-12">
                <label>Remarks:</label>
                <input class="form-control" formControlName="remarks" placeholder="Remarks" />
              </div>
            </div>
          </span>

          <span *ngIf="isTemplateSelectionMode">
            <div class="row mb-3">
              <div class="col-12">
                <label>Template:</label>

                <div class="template-inline-row">
                  <div class="template-inline-dropdown">
                    <kt-dropdown-wo-lazyload
                      [form]="form"
                      [dropdownList]="templateDropdownList"
                      [dropdownSettings]="templateDropdownSettings"
                      [formName]="'selected_template_id'"
                      [selectionAttributes]="'id'"
                      [selectedItems]="templateSelectedItems"
                      (selectedItemsChanged)="onTemplateDropdownChange($event)"
                    >
                    </kt-dropdown-wo-lazyload>
                  </div>

                  <button
                    type="button"
                    class="btn btn-dark template-inline-button"
                    [disabled]="!canEditBlacklist"
                    (click)="openBlacklistTemplateDialog()"
                  >
                    <i class="fas fa-plus mr-1"></i> Blacklist Templates
                  </button>
                </div>
              </div>
            </div>
          </span>

          <!-- Blacklist Configuration -->
          <div class="mb-2 d-flex align-items-center justify-content-between">
            <b>
              <span *ngIf="!isTemplateSelectionMode">
                Blacklist Configuration
              </span>
            </b>

            <!-- Apply to other currencies -->
            <div *ngIf="!isReadOnly && dropdown.currencies?.length" class="apply-currency">
              <span
                class="cursor-curr"
                (click)="toggleCurrencyDialog()"
              >
                Apply to other currencies <i class="fas fa-caret-down"></i>
              </span>

              <div class="currency-dropdown-container" *ngIf="showCurrencyDialog">
                <div class="currency-all-checkbox">
                  <input
                    type="checkbox"
                    (change)="toggleAllCurrencies($event)"
                    [checked]="isAllOtherCurrenciesChecked()"
                  />
                  All Currencies
                </div>

                <div *ngFor="let c of otherCurrencies()" class="currency-other-checkbox">
                  <input
                    type="checkbox"
                    [checked]="selectedAppliedCurrencies.includes(c.id)"
                    (change)="toggleCurrency(c.id)"
                  />
                  {{ c.name }}
                </div>

                <div class="apply-currency-button-container mt-2">
                  <button
                    *ngIf="beforeApplied"
                    class="btn btn-brand btn-icon-sm"
                    type="button"
                    [disabled]="selectedAppliedCurrencies.length === 0"
                    (click)="applyToOtherCurrencies()"
                  >
                    Apply
                  </button>

                  <button
                    *ngIf="afterApplied"
                    class="btn btn-success btn-icon-sm"
                    type="button"
                    disabled
                  >
                    Applied <i class="fas fa-check"></i>
                  </button>

                  <i class="fas fa-exclamation-circle"
                    matTooltip="Further changes made to the blacklist will not be automatically applied to other currencies. Repeat this step if you wish to apply changes again."
                    matTooltipClass="custom-tooltip"
                    matTooltipHideDelay="0">
                  </i>
                </div>
              </div>
            </div>
          </div>

          <mat-tab-group
            animationDuration="0ms"
            [selectedIndex]="selectedIndex"
            (selectedTabChange)="setCurrency($event)"
          >
            <mat-tab *ngFor="let currency of dropdown.currencies; let i = index">
              <ng-template mat-tab-label>{{ currency.name }}</ng-template>

              <div class="row mt-3">

                <!-- Left: Providers + Search -->
                <div class="col-md-3 border-right">
                  <div class="input-group mb-2">
                    <input type="search"
                           class="form-control search-input"
                           placeholder="Search provider..."
                           (keyup)="onSearch($event)"
                           (search)="resetKeyword($event)" />
                    <div class="input-group-append">
                      <button type="button" class="btn btn-primary" (click)="onSearch()">
                        <i class="fas fa-search"></i>
                      </button>
                    </div>
                  </div>

                  <div class="list-group">
                    <button type="button"
                            class="list-group-item list-group-item-action"
                            *ngFor="let provider of providersByCurrency[selectedIndex]"
                            [ngClass]="selectedGameProvider[selectedIndex]?.id === provider.id ? 'active' : ''"
                            (click)="setProvider(provider.id)">
                      <span [class.fw-bold]="hasAnyChecked(provider.id)">
                        {{ provider.code }} - {{ provider.name }}
                      </span>
                    </button>

                    <div class="text-muted p-2" *ngIf="providersByCurrency[selectedIndex]?.length === 0">
                      No provider found
                    </div>
                  </div>
                </div>

                <!-- Right: Categories -->
                <div class="col-md-9">
                  <div class="mb-2 text-muted">
                    Note: Ticking a category will also include all its sub categories in the blacklist.
                  </div>

                  <div *ngIf="dataLoading" class="p-3">Loading...</div>

                  <div *ngIf="!dataLoading && formReady" formArrayName="categories">
                    <div class="border rounded mb-2 p-2"
                         *ngFor="let item of filteredFormWithIndex"
                         [formGroupName]="item.idx">

                      <!-- Category Header -->
                      <div class="d-flex align-items-center justify-content-between"
                           (click)="toggleDropdown(item.group.value.game_provider_id, item.group.value.category_code)"
                           style="cursor:pointer;">
                        <div class="d-flex align-items-center">
                          <mat-checkbox class="mr-2"
                                        [disabled]="isReadOnly"
                                        [checked]="isMainChecked(item.group.value.game_provider_id, item.group.value.category_code)"
                                        [indeterminate]="isMainIndeterminate(item.group.value.game_provider_id, item.group.value.category_code)"
                                        (change)="toggleMain($event, item.group.value.game_provider_id, item.group.value.category_code)"
                                        (click)="$event.stopPropagation()">
                          </mat-checkbox>

                          <b>{{ item.group.value.category_name }}</b>
                        </div>

                        <i class="fa"
                           [ngClass]="item.group.value.expanded ? 'fa-chevron-up' : 'fa-chevron-down'">
                        </i>
                      </div>

                      <!-- Sub categories -->
                      <div class="mt-2 pl-4" *ngIf="item.group.value.expanded" formArrayName="sub_categories">
                        <div
                          *ngFor="let subCtrl of item.group.get('sub_categories').controls; let j = index"
                          [formGroupName]="j"
                          class="mb-1"
                        >
                          <mat-checkbox formControlName="status" [disabled]="isReadOnly">
                            {{ subCtrl.value.name }}
                          </mat-checkbox>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>

            </mat-tab>
          </mat-tab-group>

        </form>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" type="button" (click)="onCloseDialog()">
          <i class="fas fa-ban"></i> Cancel
        </button>

        <button
          *ngIf="!isReadOnly && !isTemplateSelectionMode"
          class="btn btn-primary"
          type="button"
          (click)="onSave()"
          [disabled]="form.invalid || saving"
        >
          <i class="fas fa-save"></i> Submit
        </button>

        <button
          *ngIf="isTemplateSelectionMode"
          class="btn btn-primary"
          type="button"
          (click)="onSave()"
          [disabled]="form.invalid || saving || !canEditBlacklist"
        >
          <i class="fas fa-save"></i> Save
        </button>
      </div>

    </div>
  </div>
</div>
<kt-swal-alert
  [message]="messages$ | async"
  [icon]="icon$ | async"
  (confirmed)="onAlertConfirmed()">
</kt-swal-alert>
